import { RouteConfig } from 'vue-router';
import MswFreeSoftwareTrial from './components/msw-free-software-trial.vue';

const route : RouteConfig = {
  path: 'free-software-trial',
  component: MswFreeSoftwareTrial,
};

export function getDefaultParams() {
  return {};
}

export default route;
